import styled from 'styled-components';
import { StyledDiv } from '../../../Theme/CommonStyled';
export const StyledPhoneContainer = styled.div`
  background-color: ${({ theme }): string => theme.colors.secondaryBackground};
  width: 100%;
  padding: 14px;
  margin-bottom: 10px;
  border-radius: ${({ theme }): string => theme.radii.xl};
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const StyledAddressContainer = styled.div`
  background-color: ${({ theme }): string => theme.colors.secondaryBackground};
  border-radius: ${({ theme }): string => theme.radii.xl};
  padding: 14px;
  margin-bottom: 16px;
`;

export const StyledSloganContainer = styled(StyledDiv)`
  background-color: ${({ theme }): string => theme.colors.secondaryBackground};
  border-radius: ${({ theme }): string => theme.radii.xl};
  padding: 14px;
  text-align: right;
  color: ${({ theme }): string => theme.colors.danger};
  font-size: ${({ theme }): string => theme.fontSizes[2]};
`;
